import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { useForm } from "react-hook-form";
import backend from "../../../api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { auth_actions } from "../../../redux-store";

const AddNewAddress = () => {
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const {
    handleSubmit,
    register,
    errors,
    reset,
    formState: { isSubmitting },
  } = useForm();
  const dispatch = useDispatch();

  const getCountries = async () => {
    try {
      const response = await backend.get("/country");
      setCountries(response?.data?.data);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const addAddressHandler = async (data) => {
    const newAddress = {
      name: data.street,
      zip: data.zip,
      state: data.state,
      country: data.country,
      city: data.city,
    };

    try {
      const response = await backend.put(
        `/user/customer/${user?._id}/add-address`,
        {
          address: newAddress,
        }
      );
      console.log("response: ", response);
      dispatch(auth_actions.login_by_token());
      toast.success("Address added successfully");
      reset();
      setOpen(false);
    } catch (error) {
      toast.error("Failed to add address");
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountry = countries.find((cn) => cn._id === e.target.value);
    setCities(selectedCountry ? selectedCountry.cities : []);
  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <>
      <button
        type="button"
        className="btn btn-sm"
        onClick={() => setOpen(true)}
      >
        Add a new Address
      </button>
      <Modal  open={open} onClose={() => setOpen(false)} center>
        <div className="container px-5 pt-5 custom-modal">
          <div className="checkout-page">
            <div className="checkout-form">
              <h3>Add New Address</h3>
              <hr />
              <form
                className="checkout"
                onSubmit={handleSubmit(addAddressHandler)}
              >
                <div className="mt-3 check-out row">
                  <div className="field-label">Street Address</div>
                  <input
                    type="text"
                    name="street"
                    placeholder="Street Address"
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                  />
                  <div className="error">
                    {errors.street && errors.street.message}
                  </div>
                </div>

                <div className="check-out row mt-3">
                  <div className="field-label">Country</div>
                  <select
                    name="country"
                    ref={register({
                      required: {
                        value: true,
                        message: "Please Select a Country",
                      },
                    })}
                    onChange={handleCountryChange}
                  >
                    <option value="">Select Country</option>
                    {countries.map((cn) => (
                      <option value={cn._id} key={cn._id}>
                        {cn.country_name}
                      </option>
                    ))}
                  </select>
                  <div className="error">
                    {errors.country && errors.country.message}
                  </div>
                </div>

                <div className="check-out row mt-3">
                  <div className="field-label">City</div>
                  <select
                    name="city"
                    ref={register({
                      required: {
                        value: true,
                        message: "Please Select a City",
                      },
                    })}
                  >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                      <option value={city._id} key={city._id}>
                        {city.city_name}
                      </option>
                    ))}
                  </select>
                  <div className="error">
                    {errors.city && errors.city.message}
                  </div>
                </div>

                <div className="check-out row mt-3">
                  <div className="field-label">State</div>
                  <input
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    type="text"
                    name="state"
                    placeholder="State"
                  />
                  <div className="error">
                    {errors.state && errors.state.message}
                  </div>
                </div>

                <div className="check-out row mt-3">
                  <div className="field-label">Zip</div>
                  <input
                    type="text"
                    name="zip"
                    placeholder="Zip"
                    ref={register({
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: /^[\d]+$/,
                        message: "This field must be a number",
                      },
                    })}
                  />
                  <div className="error">
                    {errors.zip && errors.zip.message}
                  </div>
                </div>

                <div className="check-out row mt-3 justify-content-end">
                  <button
                    className="btn btn-solid mr-2"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Adding..." : "Add"}
                  </button>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddNewAddress;
